import React from "react";

function TemplatePointers() {
  return (
    <>
      <h1 className="text-2xl mt-8 font-bold">
        !Mejora tu fluidez hablando con Inteligencia Artificial!
      </h1>
      <p className="py-2 mt-4">
        ✓ <span className="font-semibold">Practica cualquier idioma</span> donde
        y cuando quieras
      </p>
      <p className="py-2">
        ✓ <span className="font-semibold">Generación de voz</span> con las
        tecnologías de IA más avanzadas del momento
      </p>
      <p className="py-2 ">
        ✓ <span className="font-semibold">Reconocimiento de voz</span> para
        práctica de pronunciación
      </p>
      <p className="py-2">
        ✓ <span className="font-semibold">Traducciones en contexto</span> y
        explicaciones de gramática para palabras nuevas
      </p>
      <p className="py-2  ">
        <span className="font-semibold">✓ Marca palabras</span> para aumentar tu vocabulario (pronto)
      </p>
    </>
  );
}

export default TemplatePointers;
